<template>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">
        <div class="title" v-if="getModalData.id">Edit User</div>
        <div class="title" v-if="!getModalData.id">Add User</div>
      </h5>
      <button type="button" class="close" @click="$store.dispatch('closeModal', true)">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form class="form" @submit.prevent="onSubmit">
        <div class="form-group">
          <label>Role</label>
          <v-select class="form-control" v-model="form.role" :options="rolesSelect" :reduce="role => role.code"/>
        </div>
        <div class="form-group">
          <label>Email</label>
          <input type="email" class="form-control" v-model="form.email"/>
        </div>
        <div class="form-group">
          <label>Name</label>
          <input type="text" class="form-control" v-model="form.name"/>
        </div>
        <div class="form-group">
          <label>Surname</label>
          <input type="text" class="form-control" v-model="form.surname"/>
        </div>
        <div class="form-group">
          <label>Password</label>
            <input type="password" class="form-control" v-model="form.password"/>
        </div>
        <div class="form-group">
          <label>Repeat Password</label>
            <input type="password" class="form-control" v-model="form.password_confirmation"/>
        </div>
        <div class="form-group">
          <label>Phone Number</label>
            <input type="text" class="form-control" v-model="form.phone"/>
        </div>
        <div class="form-group">
          <label>Status</label>
          <div class="form-check">
            <input id="exampleRadios1" class="form-check-input" v-model="form.status" value="1" type="radio">
            <label class="form-check-label" for="exampleRadios1">Active</label>
          </div>
          <div class="form-check">
            <input id="exampleRadios2" class="form-check-input" v-model="form.status" value="0" type="radio">
            <label class="form-check-label" for="exampleRadios2">Inactive</label>
          </div>
        </div>
        <div class="form__btn">
          <b-button type="submit" variant="primary" class="mx-auto btn-image mt-4" v-if="getModalData.id">
            <img src="../../assets/img/btn-ok-icon.png"> <span>Save</span>
          </b-button>
          <b-button type="submit" variant="primary" class="mx-auto btn-image mt-4" v-else>
            <img src="../../assets/img/btn-ok-icon.png"> <span>Add</span>
          </b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'

  export default {
    name: 'ModalUser',
    computed: {
      ...mapGetters([
        'getModalData',
        'getAuthUser',
      ]),
    },
    data() {
      return {
        form: {
          email: '',
          name: '',
          surname: '',
          password: '',
          password_confirmation: '',
          role: '',
          phone: '',
          status: 1
        },
        rolesSelect: [
          {label: 'Admin', code: 'admin'},
          {label: 'User', code: 'user'},
        ],
      }
    },
    mounted() {
      if (this.getModalData.id) {
        this.form = {
          email: this.getModalData.email,
          name: this.getModalData.name,
          surname: this.getModalData.surname,
          role: this.getModalData.role,
          status: this.getModalData.status,
          phone: this.getModalData.phone,
        }
      } else {
        this.form.role = 'user'
      }
    },
    methods: {
      ...mapActions([
        'storeUser',
        'updateUser',
        'setToast',
      ]),
      onSubmit() {
        let formData = new FormData()
        formData.append('email', this.form.email)
        formData.append('name', this.form.name)
        formData.append('surname', this.form.surname)
        formData.append('phone', this.form.phone)
        if (this.form.password) {
          formData.append('password', this.form.password)
          formData.append('password_confirmation', this.form.password_confirmation)
        }
        if (this.getAuthUser.role === 'admin') {
          formData.append('role', this.form.role)
          formData.append('status', this.form.status)
        }

        if (this.getModalData.id) {
          formData.append('_method', 'PATCH')
          this.updateUser([this.getModalData.id, formData])
        } else {
          this.storeUser(formData)
        }
      }
    }
  }
</script>

<style scoped>

</style>